<app-select-product [data]="data"
                    (selectProducts)="selectProducts($event)"
                    (newProduct)="newProduct()"
                    [config]="data.config"
></app-select-product>
